import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import SideMenu from './SideMenu';
import DashboardContent from './DashboardContent';
import { Box } from '@mui/material';
import { setSelectedUserId } from '../../actions/userActions';
import { selectedUserIdSelector } from '../../selectors/userSelectors';

const Dashboard = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const selectedUserId = useSelector(selectedUserIdSelector);

  // On mount, read userId from URL and set it in Redux
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const userIdFromUrl = params.get('userId');

    if (userIdFromUrl && Number(userIdFromUrl) !== selectedUserId) {
      dispatch(setSelectedUserId(Number(userIdFromUrl)));
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Keep URL in sync with selected user
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const currentUrlUserId = params.get('userId');

    if (selectedUserId && selectedUserId !== currentUrlUserId) {
      params.set('userId', selectedUserId);
      navigate({ pathname: location.pathname, search: params.toString() }, { replace: true });
    } else if (!selectedUserId && currentUrlUserId) {
      params.delete('userId');
      navigate({ pathname: location.pathname, search: params.toString() }, { replace: true });
    }
  }, [selectedUserId, location.pathname, location.search, navigate]);

  return (
    <Box
      sx={{
        display: 'flex',
        height: '100vh'
      }}
    >
      <SideMenu />
      <DashboardContent />
    </Box>
  );
};

export default Dashboard;
